export default {
    key: 'first',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    origins: [],
    destinations: [{
        ref: 'urn:uic:stn:8507354',
        name: 'First (Grindelwald)',
    }, {
        ref: 'urn:uic:stn:8507351',
        name: 'Schreckfeld',
    }, {
        ref: 'urn:uic:stn:8507352',
        name: 'Bort',
    }],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: [],
    routeVariantUp: 'default-first',
    routeVariantDown: 'default-first',
    upsells: ['upsell-first-flyer', 'upsell-first-glider'],
    isUpsellDatesRestricted: false,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 150,
    stayDurationMin: 30,
    salesTimeLimit: 1065, // 17:45
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: 10,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:ts:listing:a3f81eb9-2519-4231-9717-35a3b5e4b1e3',
    contentfulId: 'first',
    steps: [],

} satisfies ProductConfigP2P;
